import { Spinner } from "@/components/ui/spinner"

interface PageLoaderProps {
  message?: string
}

export function PageLoader({ message }: PageLoaderProps) {
  return (
    <div className="flex h-full min-h-[400px] items-center justify-center">
      <Spinner size="lg" label={message ?? "Loading..."} />
    </div>
  )
}
